// @flow
import * as React from 'react';
import {useState} from 'react';

import Group from 'sail/Group';
import Dialog, {DialogHeader, DialogContent, DialogFooter} from 'sail/Dialog';
import {Body, Heading} from 'sail/Text';
import Button from 'sail/Button';
import {useDiagramGenerator} from 'docs/data/diagram';
import {generateId} from '../util/generateId';
import {SetNodeId} from './SetNodeId';
import {SetNodeText} from './SetNodeText';
import {SetNodeIcon} from './SetNodeIcon';

export const AddOverviewNode = () => {
  const {addNode} = useDiagramGenerator();
  const [icon, setIcon] = useState('');
  const [text, setText] = useState('');
  const [id, setId] = useState('');

  return (
    <Dialog width="large">
      <DialogHeader title="Add node" />
      <DialogContent padding={20}>
        <Group spacing={16}>
          <Group spacing={4}>
            <Heading>Node content</Heading>
            <Body>
              Overview nodes take either an icon or a string of text as content.
              We autogenerate the label for the icon nodes so you don't have to
              add text.
            </Body>
          </Group>
          <Group spacing={20} direction="horizontal">
            <SetNodeText
              text={text}
              onBlur={(evt) => {
                if (!id) {
                  setId(generateId(evt.target.value));
                }
              }}
              onChange={setText}
              disabled={icon !== ''}
            />
            <SetNodeIcon
              value={icon}
              onChange={(val) => {
                if (val !== '') {
                  // Clear any existing text since it won't be used
                  setText('');
                }
                if (id === '') {
                  // Autogenerate an ID if we don't have one defined yet
                  setId(generateId(val));
                }
                setIcon(val);
              }}
            />
          </Group>
          <SetNodeId id={id} setId={setId} />
        </Group>
      </DialogContent>
      <DialogFooter
        end={
          <Button
            label="Add"
            onClick={() => {
              addNode(
                {
                  id,
                  icon,
                },
                text,
              );
            }}
          />
        }
      />
    </Dialog>
  );
};
